import {DevilsCrossRoad} from "../DevilsCrossRoad";
import {DevilsCrossRoadGameMode} from "../server/DevilsCrossRoadGameMode";

export class DCRoadIntroScatterBox extends PIXI.Container {
    private _scatterBox: PIXI.spine.Spine[] = [];

    constructor() {
        super();
        this.init();
    }

    private init(): void {
        for (let i = 0; i < 4; i++) {
            let scatterSpine: PIXI.spine.Spine = new PIXI.spine.Spine(DevilsCrossRoad.assetLoader.getSpineAsset("S"));
            scatterSpine.name = "scatter" + `${i}`;
            scatterSpine.position.set(247 + 75 * i, 475);
            scatterSpine.visible = false;
            scatterSpine.scale.set(0.55);
            this.addChild(scatterSpine);
            this._scatterBox.push(scatterSpine);
        }
    }

    public showScatterBox(count: number): void {
        this._scatterBox.forEach((item: PIXI.spine.Spine, index: number) => {
            item.visible = true;
            if (count === 4) {
                item.state.setAnimation(0, "ver2_transition", false).timeScale = 100;
            } else if (count === 0) {
                if (DevilsCrossRoad.model.data.nextMode === DevilsCrossRoadGameMode.SUPER_FREESPIN) {
                    item.state.setAnimation(0, "ver2_transition", false).timeScale = 100;
                } else {
                    item.visible = false;
                }
            } else {
                if (count === 1) {
                    if (index === 0) {
                        item.state.setAnimation(0, "ver2_transition", false).timeScale = 100;
                    } else {
                        item.visible = false;
                        //     item.tint = 0xb3b3b3;
                        //     item.state.setAnimation(0, "idle", false).timeScale = 100;
                    }
                } else if (count === 2) {
                    if (index === 2 || index === 3) {
                        item.visible = false;
                    } else {
                        item.state.setAnimation(0, "ver2_transition", false).timeScale = 100;
                    }
                } else if (count === 3) {
                    if (index === 3) {
                        item.visible = false;
                    } else {
                        item.state.setAnimation(0, "ver2_transition", false).timeScale = 100;
                    }
                }
            }
        });
    }

    public hideScatterBox(): void {
        this._scatterBox.forEach((item: PIXI.spine.Spine) => {
            item.visible = false;
            item.tint = 0xffffff;
            item.state.clearTracks();
            item.skeleton.setToSetupPose();
            item.skeleton.setSlotsToSetupPose();
        });
    }

}